{
    "nm": "map",
    "ddd": 0,
    "h": 3240,
    "w": 5760,
    "meta": { "g": "LottieFiles AE 1.0.0" },
    "layers": [
        {
            "ty": 0,
            "nm": "loupe",
            "sr": 1,
            "st": 0,
            "op": 300,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [729, 960, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                "sk": { "a": 0, "k": 0 },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0.514, "y": 0 }, "i": { "x": 0.381, "y": 1 }, "s": [4194, 1221, 0], "t": 0, "ti": [165.333, -126.667, 0], "to": [-432, -8, 0] },
                        { "o": { "x": 0.514, "y": 0 }, "i": { "x": 0.381, "y": 1 }, "s": [1602, 1173, 0], "t": 63.902, "ti": [-432, -8, 0], "to": [-165.333, 126.667, 0] },
                        { "o": { "x": 0.514, "y": 0 }, "i": { "x": 0.381, "y": 1 }, "s": [3202, 1981, 0], "t": 129.111, "ti": [-165.333, 126.667, 0], "to": [432, 8, 0] },
                        { "s": [4194, 1221, 0], "t": 180 }
                    ],
                    "ix": 2
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0.306, "y": 0 }, "i": { "x": 0.38, "y": 1 }, "s": [0], "t": 0 },
                        { "o": { "x": 0.35, "y": -0.085 }, "i": { "x": 0.408, "y": 0.292 }, "s": [55], "t": 63.902 },
                        { "o": { "x": 0.44, "y": 0.534 }, "i": { "x": 0.518, "y": 0.201 }, "s": [20], "t": 129.111 },
                        { "s": [0], "t": 180 }
                    ],
                    "ix": 10
                },
                "sa": { "a": 0, "k": 0 },
                "o": { "a": 0, "k": 100, "ix": 11 }
            },
            "ef": [],
            "w": 1458,
            "h": 1920,
            "refId": "comp_0",
            "ind": 1
        },
        {
            "ty": 0,
            "nm": "map 2",
            "sr": 1,
            "st": 0,
            "op": 300,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [2043, 1092, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [2880, 1242, 0], "ix": 2 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "sa": { "a": 0, "k": 0 },
                "o": { "a": 0, "k": 100, "ix": 11 }
            },
            "ef": [],
            "w": 4086,
            "h": 2184,
            "refId": "comp_1",
            "ind": 2
        }
    ],
    "v": "4.8.0",
    "fr": 60,
    "op": 180,
    "ip": 0,
    "assets": [
        {
            "nm": "",
            "id": "comp_0",
            "layers": [
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [-100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [573.747, 577.693, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 20, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 2,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [13.481, 30.117],
                                                [27.818, 17.493],
                                                [21.482, 3.634],
                                                [21.205, -4.938],
                                                [17.713, -12.741],
                                                [11.516, -18.611],
                                                [-1.017, -33.006],
                                                [-19.054, -26.88],
                                                [-30.663, -11.693],
                                                [-31.935, 7.454],
                                                [-22.454, 24.061],
                                                [-5.388, 32.587]
                                            ],
                                            "o": [
                                                [-13.481, -30.117],
                                                [-18.476, -11.6],
                                                [-21.482, -3.61],
                                                [-21.205, 4.961],
                                                [-17.736, 12.741],
                                                [-17.366, 28.021],
                                                [1.017, 33.006],
                                                [19.054, 26.88],
                                                [30.686, 11.693],
                                                [31.958, -7.454],
                                                [22.454, -24.085],
                                                [5.388, -32.563]
                                            ],
                                            "v": [
                                                [151.138, -68.646],
                                                [87.801, -141.646],
                                                [27.284, -164.729],
                                                [-37.394, -162.702],
                                                [-96.361, -135.892],
                                                [-140.667, -88.399],
                                                [-165.711, 5.215],
                                                [-134.909, 97.058],
                                                [-58.645, 156.198],
                                                [37.39, 162.697],
                                                [120.822, 114.365],
                                                [163.533, 27.483]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.9804, 0.9804, 0.9804], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [573.6, 577.778, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 4,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-37.808, 1.188],
                                                [-32.073, -20.171],
                                                [-14.591, -20.567],
                                                [-5.665, -24.644],
                                                [4.139, -24.947],
                                                [13.296, -21.453],
                                                [34.478, -15.653],
                                                [37.299, 6.266],
                                                [27.564, 26.088],
                                                [8.533, 37.105],
                                                [-13.366, 35.638],
                                                [-30.778, 22.151]
                                            ],
                                            "o": [
                                                [37.808, -1.188],
                                                [21.297, 13.393],
                                                [14.591, 20.591],
                                                [5.665, 24.644],
                                                [-4.116, 24.946],
                                                [-20.026, 32.307],
                                                [-34.478, 15.676],
                                                [-37.299, -6.266],
                                                [-27.564, -26.088],
                                                [-8.533, -37.105],
                                                [13.366, -35.638],
                                                [30.778, -22.128]
                                            ],
                                            "v": [
                                                [-5.971, -192.499],
                                                [101.21, -163.406],
                                                [155.575, -111.953],
                                                [186.261, -43.449],
                                                [188.597, 31.67],
                                                [162.212, 101.968],
                                                [78.641, 175.55],
                                                [-31.431, 189.968],
                                                [-130.911, 140.354],
                                                [-186.271, 43.433],
                                                [-178.848, -68.116],
                                                [-111.14, -156.721]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 2",
                                    "ix": 2,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-12.279, -27.392],
                                                [-25.321, -15.909],
                                                [0, 0],
                                                [-19.54, -3.284],
                                                [-19.309, 4.495],
                                                [-16.118, 11.6],
                                                [-10.498, 16.934],
                                                [0.925, 30.048],
                                                [17.343, 24.457],
                                                [27.911, 10.645],
                                                [29.067, -6.778],
                                                [20.442, -21.895],
                                                [4.902, -29.652]
                                            ],
                                            "o": [
                                                [12.279, 27.392],
                                                [0, 0],
                                                [16.811, 10.575],
                                                [19.54, 3.284],
                                                [19.309, -4.496],
                                                [16.141, -11.6],
                                                [15.794, -25.506],
                                                [-0.948, -30.048],
                                                [-17.343, -24.457],
                                                [-27.911, -10.645],
                                                [-29.067, 6.778],
                                                [-20.442, 21.895],
                                                [-4.902, 29.652]
                                            ],
                                            "v": [
                                                [-137.525, 62.51],
                                                [-79.876, 128.941],
                                                [-79.922, 128.941],
                                                [-24.863, 149.928],
                                                [33.988, 148.087],
                                                [87.659, 123.7],
                                                [127.988, 80.492],
                                                [150.788, -4.69],
                                                [122.762, -88.287],
                                                [53.366, -142.117],
                                                [-34.021, -148.033],
                                                [-109.938, -104.033],
                                                [-148.809, -24.978]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                { "ty": "mm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Merge", "nm": "Merge Paths 1", "mm": 1 },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.0235, 0.0392, 0.1137], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [-100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [1133.041, 1437.564, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 2,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-13.505, 25.482],
                                                [-12.14, 26.344],
                                                [1.387, 4.379],
                                                [3.908, 2.446],
                                                [4.555, -0.699],
                                                [2.983, -3.517],
                                                [16.765, -23.456],
                                                [16.002, -23.945],
                                                [15.401, -24.341],
                                                [7.677, -12.205],
                                                [2.012, -7.011],
                                                [0.277, -3.89],
                                                [-0.809, -4.356],
                                                [-0.162, -0.349],
                                                [-2.081, -2.772],
                                                [-2.983, -1.77],
                                                [-3.422, -0.489],
                                                [-3.353, 0.885],
                                                [-3.792, 2.259],
                                                [-2.937, 2.586],
                                                [-3.561, 6.359],
                                                [-7.33, 12.438],
                                                [-14.106, 25.11]
                                            ],
                                            "o": [
                                                [13.505, -25.482],
                                                [1.85, -4.239],
                                                [-1.364, -4.426],
                                                [-3.885, -2.469],
                                                [-4.555, 0.699],
                                                [-18.129, 22.594],
                                                [-16.765, 23.456],
                                                [-16.002, 23.945],
                                                [-7.793, 12.066],
                                                [-4.116, 6.01],
                                                [-1.041, 3.75],
                                                [-0.416, 4.426],
                                                [0.092, 0.443],
                                                [0.856, 3.377],
                                                [2.081, 2.795],
                                                [2.983, 1.77],
                                                [3.422, 0.489],
                                                [4.255, -1.165],
                                                [3.399, -1.933],
                                                [5.388, -4.891],
                                                [7.515, -12.299],
                                                [14.869, -24.667],
                                                [14.129, -25.133]
                                            ],
                                            "v": [
                                                [67.825, -56.261],
                                                [106.72, -133.803],
                                                [107.437, -147.196],
                                                [99.274, -157.864],
                                                [86.186, -160.589],
                                                [74.508, -154.044],
                                                [22.501, -84.771],
                                                [-26.684, -13.705],
                                                [-73.881, 58.642],
                                                [-96.866, 95.188],
                                                [-106.116, 114.87],
                                                [-108.104, 126.354],
                                                [-107.526, 139.607],
                                                [-107.203, 140.935],
                                                [-102.763, 150.252],
                                                [-95.109, 157.147],
                                                [-85.42, 160.548],
                                                [-75.176, 159.965],
                                                [-63.058, 154.794],
                                                [-53.508, 147.969],
                                                [-40.004, 130.966],
                                                [-17.504, 94.093],
                                                [26.224, 19.557]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.0235, 0.0392, 0.1137], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 3
                },
                {
                    "ty": 4,
                    "nm": "loupe",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [729, 960, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "loupe",
                            "ix": 1,
                            "cix": 2,
                            "np": 1,
                            "it": [
                                {
                                    "ty": "rc",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Rect",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": { "a": 0, "k": [0, 0], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 4 },
                                    "s": { "a": 0, "k": [486, 640], "ix": 2 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 4
                }
            ]
        },
        {
            "nm": "",
            "id": "comp_1",
            "layers": [
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [3547.164, 1092, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 10, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 2,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [0, 0],
                                                [-86.683, 20.719],
                                                [0, 0],
                                                [64.989, -19.937]
                                            ],
                                            "o": [
                                                [86.871, -19.968],
                                                [0, 0],
                                                [-64.707, 20.75],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [-80.861, 364],
                                                [179.471, 302.969],
                                                [15.073, -364],
                                                [-179.471, -302.969]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.149, 0.1529, 0.2471], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [2061.102, 1092, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 10, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 2,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [10.957, -222.214],
                                                [-90.784, 20.813],
                                                [10.925, 222.339],
                                                [68.871, -19.937]
                                            ],
                                            "o": [
                                                [90.784, -19.874],
                                                [-10.988, -222.307],
                                                [-68.871, 20.75],
                                                [-10.957, 222.433]
                                            ],
                                            "v": [
                                                [-136.177, 364],
                                                [136.177, 302.969],
                                                [103.306, -364],
                                                [-103.306, -302.969]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.149, 0.1529, 0.2471], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [574.477, 1092, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 10, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 2,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [0, 0],
                                                [-94.729, 20.719],
                                                [0, 0],
                                                [73.003, -19.843]
                                            ],
                                            "o": [
                                                [94.885, -19.968],
                                                [0, 0],
                                                [-72.753, 20.844],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [-191.492, 364],
                                                [92.929, 302.969],
                                                [191.492, -364],
                                                [-27.141, -302.969]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.149, 0.1529, 0.2471], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 3
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [2288.54, 600.823, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 30, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 4,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-5.011, 5.01],
                                                [-7.086, 0],
                                                [0, 0],
                                                [-5.001, -5.008],
                                                [0, -7.076],
                                                [14.745, 0],
                                                [0, 14.741]
                                            ],
                                            "o": [
                                                [5.011, -5.01],
                                                [0, 0],
                                                [7.078, 0.012],
                                                [5.001, 5.008],
                                                [0, 14.741],
                                                [-14.745, 0],
                                                [0, -7.085]
                                            ],
                                            "v": [
                                                [-18.87, -27.292],
                                                [0.023, -35.116],
                                                [0.023, -35.116],
                                                [18.886, -27.276],
                                                [26.695, -8.403],
                                                [0.023, 35.116],
                                                [-26.695, -8.403]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 2",
                                    "ix": 2,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-1.76, -1.167],
                                                [-2.112, 0.009],
                                                [0, 0],
                                                [-1.981, 1.937],
                                                [-0.073, 2.769],
                                                [1.168, 1.76],
                                                [1.95, 0.812],
                                                [2.072, -0.41],
                                                [1.494, -1.493],
                                                [0.41, -2.072],
                                                [-0.813, -1.949]
                                            ],
                                            "o": [
                                                [1.76, 1.167],
                                                [0, 0],
                                                [2.771, -0.011],
                                                [1.981, -1.937],
                                                [0.009, -2.112],
                                                [-1.168, -1.76],
                                                [-1.95, -0.812],
                                                [-2.072, 0.41],
                                                [-1.494, 1.493],
                                                [-0.41, 2.072],
                                                [0.813, 1.949]
                                            ],
                                            "v": [
                                                [-5.916, 0.665],
                                                [0.023, 2.441],
                                                [0.023, 2.206],
                                                [7.433, -0.831],
                                                [10.636, -8.169],
                                                [8.859, -14.107],
                                                [4.077, -18.052],
                                                [-2.091, -18.67],
                                                [-7.561, -15.751],
                                                [-10.48, -10.283],
                                                [-9.862, -4.116]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                { "ty": "mm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Merge", "nm": "Merge Paths 1", "mm": 1 },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.149, 0.1529, 0.2471], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 4
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [2288.54, 600.823, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 4,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-5.011, 5.01],
                                                [-7.086, 0],
                                                [0, 0],
                                                [-5.001, -5.008],
                                                [0, -7.076],
                                                [14.745, 0],
                                                [0, 14.741]
                                            ],
                                            "o": [
                                                [5.011, -5.01],
                                                [0, 0],
                                                [7.078, 0.012],
                                                [5.001, 5.008],
                                                [0, 14.741],
                                                [-14.745, 0],
                                                [0, -7.085]
                                            ],
                                            "v": [
                                                [-18.87, -27.292],
                                                [0.023, -35.116],
                                                [0.023, -35.116],
                                                [18.886, -27.276],
                                                [26.695, -8.403],
                                                [0.023, 35.116],
                                                [-26.695, -8.403]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 2",
                                    "ix": 2,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-1.76, -1.167],
                                                [-2.112, 0.009],
                                                [0, 0],
                                                [-1.981, 1.937],
                                                [-0.073, 2.769],
                                                [1.168, 1.76],
                                                [1.95, 0.812],
                                                [2.072, -0.41],
                                                [1.494, -1.493],
                                                [0.41, -2.072],
                                                [-0.813, -1.949]
                                            ],
                                            "o": [
                                                [1.76, 1.167],
                                                [0, 0],
                                                [2.771, -0.011],
                                                [1.981, -1.937],
                                                [0.009, -2.112],
                                                [-1.168, -1.76],
                                                [-1.95, -0.812],
                                                [-2.072, 0.41],
                                                [-1.494, 1.493],
                                                [-0.41, 2.072],
                                                [0.813, 1.949]
                                            ],
                                            "v": [
                                                [-5.916, 0.665],
                                                [0.023, 2.441],
                                                [0.023, 2.206],
                                                [7.433, -0.831],
                                                [10.636, -8.169],
                                                [8.859, -14.107],
                                                [4.077, -18.052],
                                                [-2.091, -18.67],
                                                [-7.561, -15.751],
                                                [-10.48, -10.283],
                                                [-9.862, -4.116]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                { "ty": "mm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Merge", "nm": "Merge Paths 1", "mm": 1 },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.8196, 0, 0.3686], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 5
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [2295.865, 600.823, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 4,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [0.006, -3.506],
                                                [14.745, 0],
                                                [0, 0],
                                                [0, 14.741],
                                                [-5.011, 5.01],
                                                [-7.086, 0],
                                                [0, 0],
                                                [-3.239, -1.343],
                                                [-2.477, -2.481],
                                                [-1.338, -3.241]
                                            ],
                                            "o": [
                                                [0, 14.741],
                                                [0, 0],
                                                [-14.745, 0],
                                                [0, -7.085],
                                                [5.011, -5.01],
                                                [0, 0],
                                                [3.507, 0],
                                                [3.239, 1.343],
                                                [2.477, 2.481],
                                                [1.338, 3.241]
                                            ],
                                            "v": [
                                                [29.043, -8.403],
                                                [2.371, 35.116],
                                                [-2.324, 35.116],
                                                [-29.043, -8.403],
                                                [-21.217, -27.292],
                                                [-2.324, -35.116],
                                                [2.371, -35.116],
                                                [12.589, -33.082],
                                                [21.248, -27.289],
                                                [27.026, -18.622]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 2",
                                    "ix": 2,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [1.126, -1.125],
                                                [0.354, -1.552],
                                                [0, 0],
                                                [-1.493, -1.877],
                                                [-2.339, -0.533],
                                                [-1.35, 0.844],
                                                [-0.694, 1.433],
                                                [0.176, 1.582],
                                                [0.991, 1.246],
                                                [1.502, 0.527],
                                                [1.552, -0.353]
                                            ],
                                            "o": [
                                                [-1.126, 1.125],
                                                [0, 0],
                                                [-0.007, 2.399],
                                                [1.493, 1.877],
                                                [1.592, 0.004],
                                                [1.35, -0.844],
                                                [0.694, -1.433],
                                                [-0.176, -1.582],
                                                [-0.991, -1.246],
                                                [-1.502, -0.527],
                                                [-1.552, 0.353]
                                            ],
                                            "v": [
                                                [-5.976, -12.501],
                                                [-8.241, -8.403],
                                                [-8.241, -8.403],
                                                [-5.944, -1.798],
                                                [-0.023, 1.925],
                                                [4.48, 0.64],
                                                [7.608, -2.844],
                                                [8.401, -7.458],
                                                [6.615, -11.786],
                                                [2.798, -14.499],
                                                [-1.877, -14.765]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                { "ty": "mm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Merge", "nm": "Merge Paths 1", "mm": 1 },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [1, 0.1647, 0.5451], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 6
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [2295.725, 715.747, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 2,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-16.059, 0],
                                                [0, 5.164],
                                                [16.059, 0],
                                                [0, -5.164]
                                            ],
                                            "o": [
                                                [16.059, 0],
                                                [0, -5.211],
                                                [-16.059, 0],
                                                [0, 5.164]
                                            ],
                                            "v": [
                                                [0.023, 9.389],
                                                [29.09, 0],
                                                [0.023, -9.389],
                                                [-29.09, 0]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.4039, 0.4078, 0.4706], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 7
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [922.08, 554.063, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 30, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 4,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-5.011, 5.01],
                                                [-7.086, 0],
                                                [-5.001, -5.008],
                                                [0, -7.076],
                                                [14.745, 0],
                                                [0, 14.694]
                                            ],
                                            "o": [
                                                [5.011, -5.01],
                                                [7.078, 0.012],
                                                [5.001, 5.008],
                                                [0, 14.694],
                                                [-14.745, 0],
                                                [0, -7.085]
                                            ],
                                            "v": [
                                                [-18.87, -27.292],
                                                [0.023, -35.116],
                                                [18.886, -27.275],
                                                [26.695, -8.403],
                                                [0.023, 35.116],
                                                [-26.695, -8.403]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 2",
                                    "ix": 2,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-1.76, -1.167],
                                                [-2.112, 0.009],
                                                [0, 0],
                                                [-1.981, 1.937],
                                                [-0.073, 2.769],
                                                [1.168, 1.76],
                                                [1.95, 0.812],
                                                [2.072, -0.41],
                                                [1.494, -1.493],
                                                [0.41, -2.072],
                                                [-0.813, -1.949]
                                            ],
                                            "o": [
                                                [1.76, 1.167],
                                                [0, 0],
                                                [2.771, -0.011],
                                                [1.981, -1.937],
                                                [0.009, -2.112],
                                                [-1.168, -1.76],
                                                [-1.95, -0.812],
                                                [-2.072, 0.41],
                                                [-1.494, 1.493],
                                                [-0.41, 2.072],
                                                [0.813, 1.949]
                                            ],
                                            "v": [
                                                [-5.916, 0.665],
                                                [0.023, 2.441],
                                                [0.023, 2.206],
                                                [7.433, -0.831],
                                                [10.636, -8.169],
                                                [8.859, -14.107],
                                                [4.077, -18.052],
                                                [-2.091, -18.67],
                                                [-7.561, -15.751],
                                                [-10.48, -10.283],
                                                [-9.862, -4.116]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                { "ty": "mm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Merge", "nm": "Merge Paths 1", "mm": 1 },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.149, 0.1529, 0.2471], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 8
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [922.08, 554.063, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 4,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-5.011, 5.01],
                                                [-7.086, 0],
                                                [-5.001, -5.008],
                                                [0, -7.076],
                                                [14.745, 0],
                                                [0, 14.694]
                                            ],
                                            "o": [
                                                [5.011, -5.01],
                                                [7.078, 0.012],
                                                [5.001, 5.008],
                                                [0, 14.694],
                                                [-14.745, 0],
                                                [0, -7.085]
                                            ],
                                            "v": [
                                                [-18.87, -27.292],
                                                [0.023, -35.116],
                                                [18.886, -27.275],
                                                [26.695, -8.403],
                                                [0.023, 35.116],
                                                [-26.695, -8.403]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 2",
                                    "ix": 2,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-1.76, -1.167],
                                                [-2.112, 0.009],
                                                [0, 0],
                                                [-1.981, 1.937],
                                                [-0.073, 2.769],
                                                [1.168, 1.76],
                                                [1.95, 0.812],
                                                [2.072, -0.41],
                                                [1.494, -1.493],
                                                [0.41, -2.072],
                                                [-0.813, -1.949]
                                            ],
                                            "o": [
                                                [1.76, 1.167],
                                                [0, 0],
                                                [2.771, -0.011],
                                                [1.981, -1.937],
                                                [0.009, -2.112],
                                                [-1.168, -1.76],
                                                [-1.95, -0.812],
                                                [-2.072, 0.41],
                                                [-1.494, 1.493],
                                                [-0.41, 2.072],
                                                [0.813, 1.949]
                                            ],
                                            "v": [
                                                [-5.916, 0.665],
                                                [0.023, 2.441],
                                                [0.023, 2.206],
                                                [7.433, -0.831],
                                                [10.636, -8.169],
                                                [8.859, -14.107],
                                                [4.077, -18.052],
                                                [-2.091, -18.67],
                                                [-7.561, -15.751],
                                                [-10.48, -10.283],
                                                [-9.862, -4.116]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                { "ty": "mm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Merge", "nm": "Merge Paths 1", "mm": 1 },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.8196, 0, 0.3686], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 9
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [929.405, 554.063, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 4,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [0.006, -3.506],
                                                [14.745, 0],
                                                [0, 0],
                                                [0, 14.694],
                                                [-5.011, 5.01],
                                                [-7.086, 0],
                                                [0, 0],
                                                [-3.239, -1.343],
                                                [-2.477, -2.481],
                                                [-1.338, -3.241]
                                            ],
                                            "o": [
                                                [0, 14.694],
                                                [0, 0],
                                                [-14.745, 0],
                                                [0, -7.085],
                                                [5.011, -5.01],
                                                [0, 0],
                                                [3.507, 0],
                                                [3.239, 1.343],
                                                [2.477, 2.481],
                                                [1.338, 3.241]
                                            ],
                                            "v": [
                                                [29.043, -8.403],
                                                [2.371, 35.116],
                                                [-2.324, 35.116],
                                                [-29.043, -8.403],
                                                [-21.217, -27.292],
                                                [-2.324, -35.116],
                                                [2.371, -35.116],
                                                [12.589, -33.082],
                                                [21.248, -27.289],
                                                [27.026, -18.622]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 2",
                                    "ix": 2,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [1.126, -1.125],
                                                [0.354, -1.552],
                                                [0, 0],
                                                [-1.493, -1.877],
                                                [-2.339, -0.533],
                                                [-1.35, 0.844],
                                                [-0.694, 1.433],
                                                [0.176, 1.582],
                                                [0.991, 1.246],
                                                [1.502, 0.527],
                                                [1.552, -0.353]
                                            ],
                                            "o": [
                                                [-1.126, 1.125],
                                                [0, 0],
                                                [-0.007, 2.399],
                                                [1.493, 1.877],
                                                [1.592, 0.004],
                                                [1.35, -0.844],
                                                [0.694, -1.433],
                                                [-0.176, -1.582],
                                                [-0.991, -1.246],
                                                [-1.502, -0.527],
                                                [-1.552, 0.353]
                                            ],
                                            "v": [
                                                [-5.976, -12.501],
                                                [-8.241, -8.403],
                                                [-8.241, -8.403],
                                                [-5.944, -1.798],
                                                [-0.024, 1.925],
                                                [4.48, 0.64],
                                                [7.608, -2.844],
                                                [8.401, -7.458],
                                                [6.615, -11.786],
                                                [2.798, -14.499],
                                                [-1.877, -14.765]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                { "ty": "mm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Merge", "nm": "Merge Paths 1", "mm": 1 },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [1, 0.1647, 0.5451], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 10
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [929.264, 668.847, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 2,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-16.059, 0],
                                                [0, 5.211],
                                                [16.059, 0],
                                                [0, -5.211]
                                            ],
                                            "o": [
                                                [16.059, 0],
                                                [0, -5.164],
                                                [-16.059, 0],
                                                [0, 5.211]
                                            ],
                                            "v": [
                                                [0.023, 9.389],
                                                [29.09, 0],
                                                [0.023, -9.389],
                                                [-29.09, 0]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.4039, 0.4078, 0.4706], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 11
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [1208.541, 1367.834, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 30, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 4,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-3.239, 1.343],
                                                [-3.507, 0],
                                                [0, 0],
                                                [-3.239, -1.343],
                                                [-2.477, -2.481],
                                                [-1.338, -3.241],
                                                [0.006, -3.506],
                                                [14.745, 0],
                                                [0, 14.694],
                                                [-1.338, 3.241],
                                                [-2.477, 2.481]
                                            ],
                                            "o": [
                                                [3.239, -1.343],
                                                [0, 0],
                                                [3.507, 0],
                                                [3.239, 1.343],
                                                [2.477, 2.481],
                                                [1.338, 3.241],
                                                [0, 14.694],
                                                [-14.745, 0],
                                                [-0.006, -3.506],
                                                [1.338, -3.241],
                                                [2.477, -2.481]
                                            ],
                                            "v": [
                                                [-10.218, -33.082],
                                                [0, -35.116],
                                                [0, -35.116],
                                                [10.218, -33.082],
                                                [18.876, -27.289],
                                                [24.655, -18.622],
                                                [26.672, -8.403],
                                                [0, 35.116],
                                                [-26.672, -8.403],
                                                [-24.655, -18.622],
                                                [-18.876, -27.289]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 2",
                                    "ix": 2,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-1.76, -1.167],
                                                [-2.112, 0.009],
                                                [0, 0],
                                                [-1.984, 1.939],
                                                [-0.061, 2.773],
                                                [1.168, 1.76],
                                                [1.95, 0.812],
                                                [2.072, -0.41],
                                                [1.494, -1.493],
                                                [0.41, -2.072],
                                                [-0.813, -1.949]
                                            ],
                                            "o": [
                                                [1.76, 1.167],
                                                [0, 0],
                                                [2.774, 0.001],
                                                [1.984, -1.939],
                                                [0.009, -2.112],
                                                [-1.168, -1.76],
                                                [-1.95, -0.812],
                                                [-2.072, 0.41],
                                                [-1.494, 1.493],
                                                [-0.41, 2.072],
                                                [0.813, 1.949]
                                            ],
                                            "v": [
                                                [-5.94, 0.665],
                                                [0, 2.441],
                                                [0, 2.206],
                                                [7.422, -0.818],
                                                [10.612, -8.169],
                                                [8.836, -14.107],
                                                [4.054, -18.052],
                                                [-2.115, -18.67],
                                                [-7.584, -15.751],
                                                [-10.504, -10.283],
                                                [-9.886, -4.116]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                { "ty": "mm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Merge", "nm": "Merge Paths 1", "mm": 1 },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.149, 0.1529, 0.2471], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 12
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [1208.541, 1367.834, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 4,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-3.239, 1.343],
                                                [-3.507, 0],
                                                [0, 0],
                                                [-3.239, -1.343],
                                                [-2.477, -2.481],
                                                [-1.338, -3.241],
                                                [0.006, -3.506],
                                                [14.745, 0],
                                                [0, 14.694],
                                                [-1.338, 3.241],
                                                [-2.477, 2.481]
                                            ],
                                            "o": [
                                                [3.239, -1.343],
                                                [0, 0],
                                                [3.507, 0],
                                                [3.239, 1.343],
                                                [2.477, 2.481],
                                                [1.338, 3.241],
                                                [0, 14.694],
                                                [-14.745, 0],
                                                [-0.006, -3.506],
                                                [1.338, -3.241],
                                                [2.477, -2.481]
                                            ],
                                            "v": [
                                                [-10.218, -33.082],
                                                [0, -35.116],
                                                [0, -35.116],
                                                [10.218, -33.082],
                                                [18.876, -27.289],
                                                [24.655, -18.622],
                                                [26.672, -8.403],
                                                [0, 35.116],
                                                [-26.672, -8.403],
                                                [-24.655, -18.622],
                                                [-18.876, -27.289]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 2",
                                    "ix": 2,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-1.76, -1.167],
                                                [-2.112, 0.009],
                                                [0, 0],
                                                [-1.984, 1.939],
                                                [-0.061, 2.773],
                                                [1.168, 1.76],
                                                [1.95, 0.812],
                                                [2.072, -0.41],
                                                [1.494, -1.493],
                                                [0.41, -2.072],
                                                [-0.813, -1.949]
                                            ],
                                            "o": [
                                                [1.76, 1.167],
                                                [0, 0],
                                                [2.774, 0.001],
                                                [1.984, -1.939],
                                                [0.009, -2.112],
                                                [-1.168, -1.76],
                                                [-1.95, -0.812],
                                                [-2.072, 0.41],
                                                [-1.494, 1.493],
                                                [-0.41, 2.072],
                                                [0.813, 1.949]
                                            ],
                                            "v": [
                                                [-5.94, 0.665],
                                                [0, 2.441],
                                                [0, 2.206],
                                                [7.422, -0.818],
                                                [10.612, -8.169],
                                                [8.836, -14.107],
                                                [4.054, -18.052],
                                                [-2.115, -18.67],
                                                [-7.584, -15.751],
                                                [-10.504, -10.283],
                                                [-9.886, -4.116]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                { "ty": "mm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Merge", "nm": "Merge Paths 1", "mm": 1 },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.8196, 0, 0.3686], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 13
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [1216.011, 1367.834, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 4,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [0, -7.076],
                                                [14.698, 0],
                                                [0, 0],
                                                [0, 14.694],
                                                [-1.338, 3.241],
                                                [-2.477, 2.481],
                                                [-3.239, 1.343],
                                                [-3.507, 0],
                                                [0, 0],
                                                [-5.001, -5.008]
                                            ],
                                            "o": [
                                                [0, 14.694],
                                                [0, 0],
                                                [-14.745, 0],
                                                [-0.006, -3.506],
                                                [1.338, -3.241],
                                                [2.477, -2.481],
                                                [3.239, -1.343],
                                                [0, 0],
                                                [7.078, 0.012],
                                                [5.001, 5.008]
                                            ],
                                            "v": [
                                                [29.02, -8.403],
                                                [2.348, 35.116],
                                                [-2.348, 35.116],
                                                [-29.02, -8.403],
                                                [-27.003, -18.622],
                                                [-21.224, -27.289],
                                                [-12.566, -33.082],
                                                [-2.348, -35.116],
                                                [2.348, -35.116],
                                                [21.211, -27.275]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 2",
                                    "ix": 2,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [1.126, -1.125],
                                                [0.354, -1.552],
                                                [0, 0],
                                                [-1.491, -1.874],
                                                [-2.331, -0.548],
                                                [-1.35, 0.844],
                                                [-0.694, 1.433],
                                                [0.176, 1.582],
                                                [0.991, 1.246],
                                                [1.502, 0.527],
                                                [1.552, -0.353]
                                            ],
                                            "o": [
                                                [-1.126, 1.125],
                                                [0, 0],
                                                [0.01, 2.394],
                                                [1.491, 1.874],
                                                [1.592, 0.004],
                                                [1.35, -0.844],
                                                [0.694, -1.433],
                                                [-0.176, -1.582],
                                                [-0.991, -1.246],
                                                [-1.502, -0.527],
                                                [-1.552, 0.353]
                                            ],
                                            "v": [
                                                [-6.047, -12.501],
                                                [-8.311, -8.403],
                                                [-8.311, -8.403],
                                                [-5.994, -1.815],
                                                [-0.094, 1.925],
                                                [4.409, 0.64],
                                                [7.537, -2.844],
                                                [8.33, -7.458],
                                                [6.544, -11.786],
                                                [2.728, -14.499],
                                                [-1.947, -14.765]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                { "ty": "mm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Merge", "nm": "Merge Paths 1", "mm": 1 },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [1, 0.1647, 0.5451], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 14
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [1215.796, 1482.478, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 2,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-16.059, 0],
                                                [0, 5.211],
                                                [16.059, 0],
                                                [0, -5.211]
                                            ],
                                            "o": [
                                                [16.059, 0],
                                                [0, -5.117],
                                                [-16.059, 0],
                                                [0, 5.211]
                                            ],
                                            "v": [
                                                [-0.023, 9.389],
                                                [29.09, 0],
                                                [-0.023, -9.389],
                                                [-29.09, 0]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.4039, 0.4078, 0.4706], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 15
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [2542.531, 1300.019, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 30, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 4,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-3.241, 1.337],
                                                [-3.507, -0.006],
                                                [0, 0],
                                                [-3.236, -1.34],
                                                [-2.477, -2.476],
                                                [-1.34, -3.235],
                                                [0, -3.502],
                                                [14.745, 0],
                                                [0, 14.741],
                                                [-1.343, 3.238],
                                                [-2.482, 2.477]
                                            ],
                                            "o": [
                                                [3.241, -1.337],
                                                [0, 0],
                                                [3.503, 0],
                                                [3.236, 1.34],
                                                [2.477, 2.476],
                                                [1.34, 3.235],
                                                [0, 14.741],
                                                [-14.745, 0],
                                                [0, -3.506],
                                                [1.343, -3.238],
                                                [2.482, -2.477]
                                            ],
                                            "v": [
                                                [-10.198, -33.076],
                                                [0.023, -35.092],
                                                [0.023, -35.092],
                                                [10.23, -33.063],
                                                [18.883, -27.282],
                                                [24.665, -18.631],
                                                [26.695, -8.427],
                                                [0.023, 35.093],
                                                [-26.695, -8.427],
                                                [-24.661, -18.642],
                                                [-18.867, -27.299]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 2",
                                    "ix": 2,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-1.759, -1.165],
                                                [-2.11, 0.009],
                                                [0, 0],
                                                [-1.982, 1.947],
                                                [-0.061, 2.777],
                                                [1.173, 1.754],
                                                [1.95, 0.805],
                                                [2.069, -0.415],
                                                [1.489, -1.495],
                                                [0.406, -2.07],
                                                [-0.814, -1.946]
                                            ],
                                            "o": [
                                                [1.759, 1.165],
                                                [0, 0],
                                                [2.779, -0.012],
                                                [1.982, -1.947],
                                                [0, -2.11],
                                                [-1.173, -1.754],
                                                [-1.95, -0.805],
                                                [-2.069, 0.415],
                                                [-1.489, 1.495],
                                                [-0.406, 2.07],
                                                [0.814, 1.946]
                                            ],
                                            "v": [
                                                [-5.911, 0.692],
                                                [0.023, 2.465],
                                                [0.023, 2.23],
                                                [7.449, -0.824],
                                                [10.636, -8.192],
                                                [8.836, -14.118],
                                                [4.045, -18.042],
                                                [-2.12, -18.641],
                                                [-7.577, -15.711],
                                                [-10.484, -10.242],
                                                [-9.858, -4.081]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                { "ty": "mm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Merge", "nm": "Merge Paths 1", "mm": 1 },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.149, 0.1529, 0.2471], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 16
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [2542.531, 1300.019, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 4,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-3.241, 1.337],
                                                [-3.507, -0.006],
                                                [0, 0],
                                                [-3.236, -1.34],
                                                [-2.477, -2.476],
                                                [-1.34, -3.235],
                                                [0, -3.502],
                                                [14.745, 0],
                                                [0, 14.741],
                                                [-1.343, 3.238],
                                                [-2.482, 2.477]
                                            ],
                                            "o": [
                                                [3.241, -1.337],
                                                [0, 0],
                                                [3.503, 0],
                                                [3.236, 1.34],
                                                [2.477, 2.476],
                                                [1.34, 3.235],
                                                [0, 14.741],
                                                [-14.745, 0],
                                                [0, -3.506],
                                                [1.343, -3.238],
                                                [2.482, -2.477]
                                            ],
                                            "v": [
                                                [-10.198, -33.076],
                                                [0.023, -35.092],
                                                [0.023, -35.092],
                                                [10.23, -33.063],
                                                [18.883, -27.282],
                                                [24.665, -18.631],
                                                [26.695, -8.427],
                                                [0.023, 35.093],
                                                [-26.695, -8.427],
                                                [-24.661, -18.642],
                                                [-18.867, -27.299]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 2",
                                    "ix": 2,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-1.759, -1.165],
                                                [-2.11, 0.009],
                                                [0, 0],
                                                [-1.982, 1.947],
                                                [-0.061, 2.777],
                                                [1.173, 1.754],
                                                [1.95, 0.805],
                                                [2.069, -0.415],
                                                [1.489, -1.495],
                                                [0.406, -2.07],
                                                [-0.814, -1.946]
                                            ],
                                            "o": [
                                                [1.759, 1.165],
                                                [0, 0],
                                                [2.779, -0.012],
                                                [1.982, -1.947],
                                                [0, -2.11],
                                                [-1.173, -1.754],
                                                [-1.95, -0.805],
                                                [-2.069, 0.415],
                                                [-1.489, 1.495],
                                                [-0.406, 2.07],
                                                [0.814, 1.946]
                                            ],
                                            "v": [
                                                [-5.911, 0.692],
                                                [0.023, 2.465],
                                                [0.023, 2.23],
                                                [7.449, -0.824],
                                                [10.636, -8.192],
                                                [8.836, -14.118],
                                                [4.045, -18.042],
                                                [-2.12, -18.641],
                                                [-7.577, -15.711],
                                                [-10.484, -10.242],
                                                [-9.858, -4.081]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                { "ty": "mm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Merge", "nm": "Merge Paths 1", "mm": 1 },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.8196, 0, 0.3686], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 17
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [2549.856, 1300.019, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 4,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [0, -7.072],
                                                [14.745, 0],
                                                [0, 0],
                                                [0, 14.741],
                                                [-1.343, 3.238],
                                                [-2.482, 2.477],
                                                [-3.241, 1.337],
                                                [-3.507, -0.006],
                                                [0, 0],
                                                [-5.002, -5.001]
                                            ],
                                            "o": [
                                                [0, 14.741],
                                                [0, 0],
                                                [-14.745, 0],
                                                [0, -3.506],
                                                [1.343, -3.238],
                                                [2.482, -2.477],
                                                [3.241, -1.337],
                                                [0, 0],
                                                [7.074, 0],
                                                [5.002, 5.001]
                                            ],
                                            "v": [
                                                [29.043, -8.427],
                                                [2.371, 35.093],
                                                [-2.324, 35.093],
                                                [-29.043, -8.427],
                                                [-27.008, -18.642],
                                                [-21.215, -27.299],
                                                [-12.546, -33.076],
                                                [-2.324, -35.092],
                                                [2.371, -35.092],
                                                [21.231, -27.282]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 2",
                                    "ix": 2,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [1.126, -1.125],
                                                [0.354, -1.552],
                                                [-1.493, -1.877],
                                                [-2.339, -0.533],
                                                [-1.35, 0.844],
                                                [-0.694, 1.433],
                                                [0.176, 1.582],
                                                [0.991, 1.246],
                                                [1.502, 0.527],
                                                [1.552, -0.353]
                                            ],
                                            "o": [
                                                [-1.126, 1.125],
                                                [-0.007, 2.399],
                                                [1.493, 1.877],
                                                [1.592, 0.004],
                                                [1.35, -0.844],
                                                [0.694, -1.433],
                                                [-0.176, -1.582],
                                                [-0.991, -1.246],
                                                [-1.502, -0.527],
                                                [-1.552, 0.353]
                                            ],
                                            "v": [
                                                [-5.976, -12.525],
                                                [-8.241, -8.427],
                                                [-5.944, -1.822],
                                                [-0.023, 1.901],
                                                [4.48, 0.617],
                                                [7.608, -2.867],
                                                [8.401, -7.482],
                                                [6.615, -11.81],
                                                [2.798, -14.523],
                                                [-1.877, -14.788]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                { "ty": "mm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Merge", "nm": "Merge Paths 1", "mm": 1 },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [1, 0.1647, 0.5451], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 18
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [2549.715, 1414.874, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 2,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-16.059, 0],
                                                [0, 5.164],
                                                [16.059, 0],
                                                [0, -5.164]
                                            ],
                                            "o": [
                                                [16.059, 0],
                                                [0, -5.211],
                                                [-16.059, 0],
                                                [0, 5.164]
                                            ],
                                            "v": [
                                                [0.023, 9.389],
                                                [29.09, 0],
                                                [0.023, -9.389],
                                                [-29.09, 0]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.4039, 0.4078, 0.4706], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 19
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [3180.189, 572.935, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 30, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 4,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-3.239, 1.343],
                                                [-3.507, 0],
                                                [0, 0],
                                                [-3.239, -1.343],
                                                [-2.477, -2.481],
                                                [-1.338, -3.241],
                                                [0.006, -3.506],
                                                [14.745, 0],
                                                [0, 14.694],
                                                [-1.338, 3.241],
                                                [-2.477, 2.481]
                                            ],
                                            "o": [
                                                [3.239, -1.343],
                                                [0, 0],
                                                [3.507, 0],
                                                [3.239, 1.343],
                                                [2.477, 2.481],
                                                [1.338, 3.241],
                                                [0, 14.694],
                                                [-14.745, 0],
                                                [-0.006, -3.506],
                                                [1.338, -3.241],
                                                [2.477, -2.481]
                                            ],
                                            "v": [
                                                [-10.218, -33.082],
                                                [0, -35.116],
                                                [0, -35.116],
                                                [10.218, -33.082],
                                                [18.877, -27.289],
                                                [24.655, -18.622],
                                                [26.672, -8.403],
                                                [0, 35.116],
                                                [-26.672, -8.403],
                                                [-24.655, -18.622],
                                                [-18.876, -27.289]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 2",
                                    "ix": 2,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-1.754, -1.173],
                                                [-2.11, 0],
                                                [0, 0],
                                                [-1.293, 0.53],
                                                [-0.99, 0.986],
                                                [-0.536, 1.29],
                                                [0, 1.397],
                                                [1.166, 1.759],
                                                [1.947, 0.814],
                                                [2.071, -0.406],
                                                [1.495, -1.488],
                                                [0.415, -2.068],
                                                [-0.805, -1.95]
                                            ],
                                            "o": [
                                                [1.754, 1.173],
                                                [0, 0],
                                                [1.398, 0.006],
                                                [1.293, -0.53],
                                                [0.99, -0.986],
                                                [0.536, -1.29],
                                                [0.009, -2.11],
                                                [-1.166, -1.759],
                                                [-1.947, -0.814],
                                                [-2.071, 0.406],
                                                [-1.495, 1.488],
                                                [-0.415, 2.068],
                                                [0.805, 1.95]
                                            ],
                                            "v": [
                                                [-5.927, 0.407],
                                                [0, 2.206],
                                                [0, 2.206],
                                                [4.076, 1.412],
                                                [7.535, -0.884],
                                                [9.847, -4.332],
                                                [10.659, -8.403],
                                                [8.886, -14.337],
                                                [4.112, -18.282],
                                                [-2.051, -18.908],
                                                [-7.52, -16.003],
                                                [-10.451, -10.547],
                                                [-9.852, -4.383]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                { "ty": "mm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Merge", "nm": "Merge Paths 1", "mm": 1 },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.149, 0.1529, 0.2471], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 20
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [3180.189, 572.935, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 4,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-3.239, 1.343],
                                                [-3.507, 0],
                                                [0, 0],
                                                [-3.239, -1.343],
                                                [-2.477, -2.481],
                                                [-1.338, -3.241],
                                                [0.006, -3.506],
                                                [14.745, 0],
                                                [0, 14.694],
                                                [-1.338, 3.241],
                                                [-2.477, 2.481]
                                            ],
                                            "o": [
                                                [3.239, -1.343],
                                                [0, 0],
                                                [3.507, 0],
                                                [3.239, 1.343],
                                                [2.477, 2.481],
                                                [1.338, 3.241],
                                                [0, 14.694],
                                                [-14.745, 0],
                                                [-0.006, -3.506],
                                                [1.338, -3.241],
                                                [2.477, -2.481]
                                            ],
                                            "v": [
                                                [-10.218, -33.082],
                                                [0, -35.116],
                                                [0, -35.116],
                                                [10.218, -33.082],
                                                [18.877, -27.289],
                                                [24.655, -18.622],
                                                [26.672, -8.403],
                                                [0, 35.116],
                                                [-26.672, -8.403],
                                                [-24.655, -18.622],
                                                [-18.876, -27.289]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 2",
                                    "ix": 2,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-1.754, -1.173],
                                                [-2.11, 0],
                                                [0, 0],
                                                [-1.293, 0.53],
                                                [-0.99, 0.986],
                                                [-0.536, 1.29],
                                                [0, 1.397],
                                                [1.166, 1.759],
                                                [1.947, 0.814],
                                                [2.071, -0.406],
                                                [1.495, -1.488],
                                                [0.415, -2.068],
                                                [-0.805, -1.95]
                                            ],
                                            "o": [
                                                [1.754, 1.173],
                                                [0, 0],
                                                [1.398, 0.006],
                                                [1.293, -0.53],
                                                [0.99, -0.986],
                                                [0.536, -1.29],
                                                [0.009, -2.11],
                                                [-1.166, -1.759],
                                                [-1.947, -0.814],
                                                [-2.071, 0.406],
                                                [-1.495, 1.488],
                                                [-0.415, 2.068],
                                                [0.805, 1.95]
                                            ],
                                            "v": [
                                                [-5.927, 0.407],
                                                [0, 2.206],
                                                [0, 2.206],
                                                [4.076, 1.412],
                                                [7.535, -0.884],
                                                [9.847, -4.332],
                                                [10.659, -8.403],
                                                [8.886, -14.337],
                                                [4.112, -18.282],
                                                [-2.051, -18.908],
                                                [-7.52, -16.003],
                                                [-10.451, -10.547],
                                                [-9.852, -4.383]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                { "ty": "mm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Merge", "nm": "Merge Paths 1", "mm": 1 },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.8196, 0, 0.3686], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 21
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [3187.659, 572.935, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 4,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [0, -7.076],
                                                [14.698, 0],
                                                [0, 0],
                                                [0, 14.694],
                                                [-1.338, 3.241],
                                                [-2.477, 2.481],
                                                [-3.239, 1.343],
                                                [-3.507, 0],
                                                [0, 0],
                                                [-5.001, -5.008]
                                            ],
                                            "o": [
                                                [0, 14.694],
                                                [0, 0],
                                                [-14.745, 0],
                                                [-0.006, -3.506],
                                                [1.338, -3.241],
                                                [2.477, -2.481],
                                                [3.239, -1.343],
                                                [0, 0],
                                                [7.078, 0.012],
                                                [5.001, 5.008]
                                            ],
                                            "v": [
                                                [29.02, -8.403],
                                                [2.348, 35.116],
                                                [-2.348, 35.116],
                                                [-29.02, -8.403],
                                                [-27.003, -18.622],
                                                [-21.224, -27.289],
                                                [-12.566, -33.082],
                                                [-2.348, -35.116],
                                                [2.348, -35.116],
                                                [21.211, -27.275]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 2",
                                    "ix": 2,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [1.126, -1.125],
                                                [0.354, -1.552],
                                                [-1.491, -1.874],
                                                [-2.331, -0.548],
                                                [-1.35, 0.844],
                                                [-0.694, 1.433],
                                                [0.176, 1.582],
                                                [0.991, 1.246],
                                                [1.502, 0.527],
                                                [1.552, -0.353]
                                            ],
                                            "o": [
                                                [-1.126, 1.125],
                                                [0.01, 2.394],
                                                [1.491, 1.874],
                                                [1.592, 0.004],
                                                [1.35, -0.844],
                                                [0.694, -1.433],
                                                [-0.176, -1.582],
                                                [-0.991, -1.246],
                                                [-1.502, -0.527],
                                                [-1.552, 0.353]
                                            ],
                                            "v": [
                                                [-6.047, -12.501],
                                                [-8.311, -8.403],
                                                [-5.994, -1.815],
                                                [-0.094, 1.925],
                                                [4.409, 0.64],
                                                [7.538, -2.844],
                                                [8.33, -7.458],
                                                [6.544, -11.786],
                                                [2.728, -14.499],
                                                [-1.947, -14.765]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                { "ty": "mm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Merge", "nm": "Merge Paths 1", "mm": 1 },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [1, 0.1647, 0.5451], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 22
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [3187.444, 687.719, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 2,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-16.059, 0],
                                                [0, 5.211],
                                                [16.059, 0],
                                                [0, -5.211]
                                            ],
                                            "o": [
                                                [16.059, 0],
                                                [0, -5.164],
                                                [-16.059, 0],
                                                [0, 5.211]
                                            ],
                                            "v": [
                                                [-0.023, 9.389],
                                                [29.09, 0],
                                                [-0.023, -9.389],
                                                [-29.09, 0]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.4039, 0.4078, 0.4706], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 23
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [2035.111, 1105.027, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 4,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [0, 0],
                                                [76.728, 6.26],
                                                [31.274, -10.751],
                                                [18.126, -60.937],
                                                [-47.333, -12.081],
                                                [-77.855, 26.885],
                                                [-68.495, 12.832],
                                                [-2.677, -11.455],
                                                [66.961, -12.112],
                                                [0, 0],
                                                [-23.479, -32.863],
                                                [-58.697, -32.08],
                                                [0, 0],
                                                [51.904, 30.046],
                                                [24.747, 37.041],
                                                [60.857, -19.561],
                                                [85.369, 22.628],
                                                [0, 0],
                                                [-26.954, -72.392],
                                                [0, 0],
                                                [21.413, 72.767],
                                                [0, 0],
                                                [74.161, -18.528],
                                                [-2.724, 11.69],
                                                [-72.158, 19.185],
                                                [0, 0],
                                                [24.84, 59.904],
                                                [64.895, -9.389],
                                                [-1.737, 7.605],
                                                [-63.674, 9.389],
                                                [-26.39, 61.938],
                                                [0, 0],
                                                [27.329, -59.81],
                                                [-71.438, -11.267],
                                                [0, 0],
                                                [-32.87, 11.924],
                                                [0, 0],
                                                [20.912, 65.35],
                                                [0, 0],
                                                [-22.884, -63.19],
                                                [0, 0],
                                                [-61.17, 17.402],
                                                [0, 0],
                                                [61.42, -16.588]
                                            ],
                                            "o": [
                                                [-76.666, -6.26],
                                                [-30.757, 11.032],
                                                [-15.715, 61.594],
                                                [47.239, 12.425],
                                                [78.231, -25.633],
                                                [68.527, -12.519],
                                                [2.63, 11.455],
                                                [-66.93, 12.394],
                                                [0, 0],
                                                [22.352, 33.003],
                                                [57.977, 33.301],
                                                [0, 0],
                                                [-52.686, -28.763],
                                                [-26.202, -37.041],
                                                [-60.575, 20.5],
                                                [-85.776, -21.721],
                                                [0, 0],
                                                [22.587, 74.082],
                                                [0, 0],
                                                [-25.733, -71.312],
                                                [0, 0],
                                                [-73.942, 19.279],
                                                [2.677, -11.69],
                                                [72.408, -18.372],
                                                [0, 0],
                                                [-28.503, -58.261],
                                                [-64.926, 9.389],
                                                [1.737, -7.371],
                                                [63.737, -9.045],
                                                [28.331, -60.999],
                                                [0, 0],
                                                [-25.388, 60.592],
                                                [71.375, 11.549],
                                                [0, 0],
                                                [33.715, -11.924],
                                                [0, 0],
                                                [-22.727, -64.692],
                                                [0, 0],
                                                [20.943, 63.691],
                                                [0, 0],
                                                [61.389, -16.65],
                                                [0, 0],
                                                [-61.233, 17.182],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [354.787, -88.119],
                                                [124.695, -106.897],
                                                [47.169, -79.387],
                                                [-3.592, 104.409],
                                                [138.266, 141.168],
                                                [372.396, 62.392],
                                                [577.928, 24.365],
                                                [584.55, 53.003],
                                                [383.713, 89.762],
                                                [349.856, 101.358],
                                                [407.238, 183.843],
                                                [582.249, 281.914],
                                                [543.462, 291.303],
                                                [386.577, 203.091],
                                                [322.809, 110.512],
                                                [140.661, 170.604],
                                                [-116.055, 104.08],
                                                [-222.79, 95.442],
                                                [-148.879, 315.575],
                                                [-173.625, 309.941],
                                                [-244.061, 93.658],
                                                [-362.394, 84.269],
                                                [-584.55, 140.98],
                                                [-577.788, 111.733],
                                                [-360.938, 55.397],
                                                [-256.928, 63.753],
                                                [-337.741, -112.906],
                                                [-532.474, -84.739],
                                                [-528.107, -103.517],
                                                [-336.99, -131.169],
                                                [-254.908, -315.575],
                                                [-239.553, -310.88],
                                                [-318.63, -130.277],
                                                [-104.41, -96.053],
                                                [38.012, -96.053],
                                                [121.268, -125.911],
                                                [244.343, -115.817],
                                                [178.884, -310.88],
                                                [202.363, -304.214],
                                                [268.104, -113.892],
                                                [351.735, -107.085],
                                                [535.573, -158.163],
                                                [540.269, -138.774],
                                                [356.29, -88.119]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 2",
                                    "ix": 2,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [0, 0],
                                                [-35.077, -9.389],
                                                [0, 0],
                                                [-15.746, 59.372],
                                                [0, 0],
                                                [69.56, 11.142],
                                                [-28.973, -58.167]
                                            ],
                                            "o": [
                                                [34.42, 9.108],
                                                [0, 0],
                                                [17.875, -58.621],
                                                [0, 0],
                                                [-69.56, -10.766],
                                                [25.357, 59.857],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [-109.153, 76.241],
                                                [-22.234, 99.433],
                                                [-22.469, 99.433],
                                                [27.963, -77.556],
                                                [-107.133, -77.556],
                                                [-315.812, -110.418],
                                                [-233.449, 66.054]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                { "ty": "mm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Merge", "nm": "Merge Paths 1", "mm": 1 },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 24
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [733.384, 1569.164, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 2,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-5.494, 29.482],
                                                [-32.87, 10.281],
                                                [4.837, -31.219],
                                                [34.185, -8.544]
                                            ],
                                            "o": [
                                                [33.575, -10.234],
                                                [-4.884, 31.219],
                                                [-33.622, 8.544],
                                                [5.541, -29.482]
                                            ],
                                            "v": [
                                                [-34.655, -24.06],
                                                [48.46, -49.693],
                                                [36.298, 28.379],
                                                [-48.46, 49.693]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.0235, 0.0392, 0.1137], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 25
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [3175.684, 619.695, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 50, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 2,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [0, 0],
                                                [-16.717, 6.619],
                                                [-3.287, -20.14],
                                                [17.515, -5.493]
                                            ],
                                            "o": [
                                                [17.14, -6.619],
                                                [3.522, 20.14],
                                                [-17.327, 5.54],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [-25.404, -15.539],
                                                [16.858, -32.064],
                                                [25.404, 18.309],
                                                [-18.126, 32.064]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.0235, 0.0392, 0.1137], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 26
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [2550.284, 1081.366, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 2,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [24.253, -22.253],
                                                [-28.245, -29.389],
                                                [-25.193, 25.257],
                                                [28.245, 29.389]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.0235, 0.0392, 0.1137], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 27
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [2734.613, 993.271, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 2,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [4.461, 35.492],
                                                [0, 0],
                                                [-1.033, -14.835],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [0.845, 14.882],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-4.461, -35.492]
                                            ],
                                            "v": [
                                                [72.549, -37.815],
                                                [-83.678, -50.96],
                                                [-81.33, -13.779],
                                                [-24.981, -6.69],
                                                [-20.99, 41.008],
                                                [83.678, 50.96]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.0235, 0.0392, 0.1137], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 28
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [1556.053, 1060.452, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 20, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 2,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-32.87, -43.613],
                                                [-3.522, -37.557],
                                                [-18.454, -42.393],
                                                [0, 0],
                                                [2.489, 41.829],
                                                [11.223, 12.629],
                                                [44.187, -8.403],
                                                [0, 0],
                                                [0, 0],
                                                [24.887, 89.198],
                                                [48.507, 14.882],
                                                [2.724, 14.084],
                                                [16.717, 0.798],
                                                [18.313, 11.831],
                                                [-21.835, 48.731],
                                                [-1.315, 2.864],
                                                [0, 0],
                                                [-12.256, -8.169],
                                                [-15.073, -0.704],
                                                [-4.367, -19.858],
                                                [-14.839, -4.695],
                                                [-14.745, -60.185],
                                                [-5.494, -9.389]
                                            ],
                                            "o": [
                                                [14.745, 19.718],
                                                [3.522, 37.369],
                                                [0, 0],
                                                [-12.725, -41.501],
                                                [-2.207, -33.614],
                                                [-28.597, -32.158],
                                                [0, 0],
                                                [0, 0],
                                                [-2.911, -2.676],
                                                [-14.886, -53.472],
                                                [-28.456, -8.732],
                                                [-1.033, -5.258],
                                                [-16.717, -0.798],
                                                [-18.313, -11.831],
                                                [1.315, -2.911],
                                                [0, 0],
                                                [-18.36, 37.135],
                                                [13.712, 9.108],
                                                [18.783, 0.845],
                                                [3.052, 4.319],
                                                [52.592, 16.948],
                                                [15.449, 63.049],
                                                [49.399, -9.014]
                                            ],
                                            "v": [
                                                [215.965, 68.847],
                                                [237.096, 160.252],
                                                [263.204, 284.05],
                                                [226.108, 292.594],
                                                [212.397, 161.895],
                                                [196.102, 81.851],
                                                [51.52, 68.143],
                                                [45.463, 69.41],
                                                [41.096, 65.373],
                                                [-2.058, -47.627],
                                                [-124.429, -138.657],
                                                [-173.03, -167.717],
                                                [-198.763, -174.665],
                                                [-254.032, -188.091],
                                                [-239.24, -279.731],
                                                [-235.249, -288.369],
                                                [-219.8, -292.594],
                                                [-239.991, -208.748],
                                                [-194.02, -198.138],
                                                [-151.758, -176.496],
                                                [-115.507, -161.191],
                                                [20.012, -55.045],
                                                [55.042, 43.543]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 29
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [1556.053, 1060.452, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 2,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-32.87, -43.613],
                                                [-3.522, -37.557],
                                                [-18.454, -42.393],
                                                [0, 0],
                                                [2.489, 41.829],
                                                [11.223, 12.629],
                                                [44.187, -8.403],
                                                [0, 0],
                                                [0, 0],
                                                [24.887, 89.198],
                                                [48.507, 14.882],
                                                [2.724, 14.084],
                                                [16.717, 0.798],
                                                [18.313, 11.831],
                                                [-21.835, 48.731],
                                                [-1.315, 2.864],
                                                [0, 0],
                                                [-12.256, -8.169],
                                                [-15.073, -0.704],
                                                [-4.367, -19.858],
                                                [-14.839, -4.695],
                                                [-14.745, -60.185],
                                                [-5.494, -9.389]
                                            ],
                                            "o": [
                                                [14.745, 19.718],
                                                [3.522, 37.369],
                                                [0, 0],
                                                [-12.725, -41.501],
                                                [-2.207, -33.614],
                                                [-28.597, -32.158],
                                                [0, 0],
                                                [0, 0],
                                                [-2.911, -2.676],
                                                [-14.886, -53.472],
                                                [-28.456, -8.732],
                                                [-1.033, -5.258],
                                                [-16.717, -0.798],
                                                [-18.313, -11.831],
                                                [1.315, -2.911],
                                                [0, 0],
                                                [-18.36, 37.135],
                                                [13.712, 9.108],
                                                [18.783, 0.845],
                                                [3.052, 4.319],
                                                [52.592, 16.948],
                                                [15.449, 63.049],
                                                [49.399, -9.014]
                                            ],
                                            "v": [
                                                [215.965, 68.847],
                                                [237.096, 160.252],
                                                [263.204, 284.05],
                                                [226.108, 292.594],
                                                [212.397, 161.895],
                                                [196.102, 81.851],
                                                [51.52, 68.143],
                                                [45.463, 69.41],
                                                [41.096, 65.373],
                                                [-2.058, -47.627],
                                                [-124.429, -138.657],
                                                [-173.03, -167.717],
                                                [-198.763, -174.665],
                                                [-254.032, -188.091],
                                                [-239.24, -279.731],
                                                [-235.249, -288.369],
                                                [-219.8, -292.594],
                                                [-239.991, -208.748],
                                                [-194.02, -198.138],
                                                [-151.758, -176.496],
                                                [-115.507, -161.191],
                                                [20.012, -55.045],
                                                [55.042, 43.543]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.8196, 0, 0.3686], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 30
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [2051.454, 1092, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 40, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 2,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [91.442, 20.813],
                                                [89.595, -19.905],
                                                [87.247, 20.688],
                                                [78.669, -16.963],
                                                [-45.455, 196.487],
                                                [-62.172, 17.495],
                                                [-68.245, -19.937],
                                                [-70.06, 20.688],
                                                [-72.252, -19.811],
                                                [-55.879, 17.558],
                                                [-45.455, -196.518],
                                                [72.408, -16.838]
                                            ],
                                            "o": [
                                                [-89.438, 20.782],
                                                [-87.623, -20.031],
                                                [-78.513, 17.464],
                                                [45.33, -196.487],
                                                [62.328, -16.932],
                                                [67.994, 20.75],
                                                [70.217, -19.999],
                                                [72.001, 20.876],
                                                [56.161, -16.869],
                                                [45.33, 196.487],
                                                [-72.314, 17.589],
                                                [-91.63, -19.874]
                                            ],
                                            "v": [
                                                [137.468, 264.239],
                                                [-131.082, 325.269],
                                                [-393.386, 264.192],
                                                [-629.159, 315.833],
                                                [-492.983, -273.628],
                                                [-306.233, -325.269],
                                                [-101.874, -264.239],
                                                [108.542, -325.269],
                                                [324.922, -264.239],
                                                [492.983, -315.88],
                                                [629.159, 273.628],
                                                [412.075, 325.269]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 31
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [2051.454, 1092, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 2,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [91.442, 20.813],
                                                [89.595, -19.905],
                                                [87.247, 20.688],
                                                [78.669, -16.963],
                                                [-45.455, 196.487],
                                                [-62.172, 17.495],
                                                [-68.245, -19.937],
                                                [-70.06, 20.688],
                                                [-72.252, -19.811],
                                                [-55.879, 17.558],
                                                [-45.455, -196.518],
                                                [72.408, -16.838]
                                            ],
                                            "o": [
                                                [-89.438, 20.782],
                                                [-87.623, -20.031],
                                                [-78.513, 17.464],
                                                [45.33, -196.487],
                                                [62.328, -16.932],
                                                [67.994, 20.75],
                                                [70.217, -19.999],
                                                [72.001, 20.876],
                                                [56.161, -16.869],
                                                [45.33, 196.487],
                                                [-72.314, 17.589],
                                                [-91.63, -19.874]
                                            ],
                                            "v": [
                                                [137.468, 264.239],
                                                [-131.082, 325.269],
                                                [-393.386, 264.192],
                                                [-629.159, 315.833],
                                                [-492.983, -273.628],
                                                [-306.233, -325.269],
                                                [-101.874, -264.239],
                                                [108.542, -325.269],
                                                [324.922, -264.239],
                                                [492.983, -315.88],
                                                [629.159, 273.628],
                                                [412.075, 325.269]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.8196, 0, 0.3686], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 32
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [2043.141, 1092, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 80, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 2,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-68.871, 20.75],
                                                [-71, -19.811],
                                                [-64.77, 20.75],
                                                [0, 0],
                                                [86.871, -19.999],
                                                [92.694, 20.813],
                                                [90.784, -19.905],
                                                [88.687, 20.719],
                                                [94.885, -19.999],
                                                [0, 0],
                                                [-72.753, 20.876],
                                                [-66.993, -19.937]
                                            ],
                                            "o": [
                                                [70.718, 20.876],
                                                [64.989, -19.937],
                                                [0, 0],
                                                [-86.683, 20.688],
                                                [-92.913, -19.874],
                                                [-90.784, 20.782],
                                                [-88.906, -19.968],
                                                [-94.729, 20.688],
                                                [0, 0],
                                                [73.003, -19.811],
                                                [66.711, 20.75],
                                                [68.871, -19.937]
                                            ],
                                            "v": [
                                                [109.246, -364],
                                                [321.823, -302.969],
                                                [516.461, -364],
                                                [680.953, 302.969],
                                                [420.621, 364],
                                                [142.211, 302.969],
                                                [-130.143, 364],
                                                [-396.532, 302.969],
                                                [-680.953, 364],
                                                [-516.555, -302.969],
                                                [-297.921, -364],
                                                [-97.366, -302.969]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 33
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [2043.141, 1092, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "Vector",
                            "ix": 1,
                            "cix": 2,
                            "np": 2,
                            "it": [
                                {
                                    "ty": "sh",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Group",
                                    "nm": "Path 1",
                                    "ix": 1,
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [-68.871, 20.75],
                                                [-71, -19.811],
                                                [-64.77, 20.75],
                                                [0, 0],
                                                [86.871, -19.999],
                                                [92.694, 20.813],
                                                [90.784, -19.905],
                                                [88.687, 20.719],
                                                [94.885, -19.999],
                                                [0, 0],
                                                [-72.753, 20.876],
                                                [-66.993, -19.937]
                                            ],
                                            "o": [
                                                [70.718, 20.876],
                                                [64.989, -19.937],
                                                [0, 0],
                                                [-86.683, 20.688],
                                                [-92.913, -19.874],
                                                [-90.784, 20.782],
                                                [-88.906, -19.968],
                                                [-94.729, 20.688],
                                                [0, 0],
                                                [73.003, -19.811],
                                                [66.711, 20.75],
                                                [68.871, -19.937]
                                            ],
                                            "v": [
                                                [109.246, -364],
                                                [321.823, -302.969],
                                                [516.461, -364],
                                                [680.953, 302.969],
                                                [420.621, 364],
                                                [142.211, 302.969],
                                                [-130.143, 364],
                                                [-396.532, 302.969],
                                                [-680.953, 364],
                                                [-516.555, -302.969],
                                                [-297.921, -364],
                                                [-97.366, -302.969]
                                            ]
                                        },
                                        "ix": 2
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "nm": "Fill 1",
                                    "c": { "a": 0, "k": [0.8196, 0, 0.3686], "ix": 4 },
                                    "r": 1,
                                    "o": { "a": 0, "k": 100, "ix": 5 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 34
                },
                {
                    "ty": 4,
                    "nm": "map",
                    "sr": 1,
                    "st": 0,
                    "op": 300,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [2043, 1092, 0], "ix": 2 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100, "ix": 11 }
                    },
                    "ef": [],
                    "shapes": [
                        {
                            "ty": "gr",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Group",
                            "nm": "map",
                            "ix": 1,
                            "cix": 2,
                            "np": 1,
                            "it": [
                                {
                                    "ty": "rc",
                                    "bm": 0,
                                    "hd": false,
                                    "mn": "ADBE Vector Shape - Rect",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": { "a": 0, "k": [0, 0], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 4 },
                                    "s": { "a": 0, "k": [1362, 728], "ix": 2 }
                                },
                                {
                                    "ty": "tr",
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [300, 300], "ix": 3 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "o": { "a": 0, "k": 100, "ix": 7 }
                                }
                            ]
                        }
                    ],
                    "ind": 35
                }
            ]
        }
    ]
}
